export type IconDimension = {
  width: string;
  height: string;
};

export const DEFAULT_ARROW_ICON_SIZES: IconDimension = {
  height: '18',
  width: '18'
};
